// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__EnrollmentComponent__enrollmentInlineWarning *{font-weight:700!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-enrollment-react/components/EnrollmentComponent/EnrollmentComponent.module.scss"],"names":[],"mappings":"AAAA,qDACI,yBAAA","sourcesContent":[".enrollmentInlineWarning * {\n    font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"enrollmentInlineWarning": "app__EnrollmentComponent__enrollmentInlineWarning"
};
export default ___CSS_LOADER_EXPORT___;
